import React, { useState } from "react";
import {
  Divider,
  Button,
  Grid,
  Box,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Link,
  Tooltip,
} from "@mui/material";
import AttachmentIcon from "@mui/icons-material/Attachment";
import { useNotificationContext } from "../../common/NotificationContext";
import { useLoading } from "../../common/LoadingContext";
import download from "downloadjs";
import { downloadQueryDocument } from "../../services/queryServices";
import NoDataComponent from "../../common/RecordNotFound";
import { convertDateFromUTCString, shortenFileName } from "../../utils/jsUtils";

export default function AttachmentListPopup({ Filelist }) {
  const [open, setOpen] = useState(false);

  const { showNotification } = useNotificationContext();
  const { setLoading } = useLoading();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          color: "#6060d9",
          marginLeft: "10px",
          cursor: "pointer",
        }}
        onClick={handleClickOpen}
      >
        <AttachmentIcon />
        Attachments
      </div>
      {open && (
        <Dialog
          fullWidth
          maxWidth="md"
          open={open}
          onClose={handleClose}
          disableEscapeKeyDown={true}
        >
          <DialogTitle>
            <Typography variant="h6" color="primary">
              Attachments
            </Typography>
          </DialogTitle>
          <Divider />
          <DialogContent>
            <Grid>
              <Grid item xs={12} md={12}>
                <Grid item xs={12} md={12}>
                  <Box sx={{ mt: 0 }}>
                    {open && (
                      <form>
                        <Grid
                          container
                          spacing={1}
                          direction="row"
                          justifyContent="left"
                          alignItems="center"
                        >
                          <Grid item xs={12} sm={12}>
                            {Filelist?.length > 0 ? (
                              <TableContainer
                                sx={{ maxHeight: 720 }}
                                className="tableScroll"
                              >
                                <Table stickyHeader aria-label="sticky table">
                                  <TableHead>
                                    <TableRow key={"1"}>
                                      <TableCell
                                        className="tableHeader"
                                        size="small"
                                        variant="head"
                                        sx={{ pt: 1.5, pb: 1.5 }}
                                      >
                                        File Name
                                      </TableCell>
                                      <TableCell
                                        className="tableHeader"
                                        size="small"
                                        variant="head"
                                        sx={{ pt: 1.5, pb: 1.5 }}
                                      >
                                        Upload by
                                      </TableCell>
                                      <TableCell
                                        className="tableHeader"
                                        size="small"
                                        variant="head"
                                        sx={{ pt: 1.5, pb: 1.5 }}
                                      >
                                        Upload Date
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {Filelist && Filelist.length > 0
                                      ? Filelist.map((item) => (
                                          <TableRow
                                            key={item.documentId}
                                            hover
                                            tabIndex={-1}
                                          >
                                            <TableCell
                                              size="small"
                                              sx={{
                                                pt: 1.5,
                                                pb: 1.5,
                                                fontSize: "13px",
                                              }}
                                            >
                                              <Link
                                                onClick={async () => {
                                                  try {
                                                    setLoading(true);
                                                    const downloadResponse =
                                                      await downloadQueryDocument(
                                                        baseUrl,
                                                        item.documentId
                                                      );

                                                    const content =
                                                      downloadResponse.headers[
                                                        "content-type"
                                                      ];
                                                    download(
                                                      downloadResponse.data,
                                                      item?.fileName ??
                                                        "Attachment",
                                                      content
                                                    );
                                                  } catch (err) {
                                                    showNotification(
                                                      "Error",
                                                      "Failed To Fetch Query Attachments"
                                                    );
                                                  } finally {
                                                    setLoading(false);
                                                  }
                                                }}
                                                variant="body2"
                                              >
                                                <Tooltip title={item.fileName}>
                                                  <Typography
                                                    whiteSpace={"nowrap"}
                                                    overflow={"hidden"}
                                                    variant="caption"
                                                    display={"list-item"}
                                                    ml={1}
                                                  >
                                                    {shortenFileName(
                                                      item?.fileName
                                                    )}
                                                  </Typography>
                                                </Tooltip>
                                              </Link>
                                            </TableCell>
                                            <TableCell
                                              size="small"
                                              sx={{
                                                pt: 1.5,
                                                pb: 1.5,
                                                fontSize: "13px",
                                              }}
                                            >
                                              {item.uploadedBy}
                                            </TableCell>
                                            <TableCell
                                              size="small"
                                              sx={{
                                                pt: 1.5,
                                                pb: 1.5,
                                                fontSize: "13px",
                                              }}
                                            >
                                              {item?.uploadedDate
                                                ? convertDateFromUTCString(
                                                    item.uploadedDate
                                                  )
                                                : "-"}
                                            </TableCell>
                                          </TableRow>
                                        ))
                                      : ""}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            ) : (
                              <NoDataComponent label={"No Attachment Found"} />
                            )}
                          </Grid>
                        </Grid>
                      </form>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <Divider />
          <DialogActions>
            <Button
              variant="outlined"
              sx={{ fontSize: "13px" }}
              onClick={handleClose}
              color="error"
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
